import React from "react";
import "./BudgetTotalMonthCard.scss";
import iconBudgetCard from "../../../assets/image/budget/icon-budget-card.svg";

const BudgetTotalMonthCard = ({ title, totalBudget, previousTotalBudget, agentCommissionBudget, expensesBudget  }) => {
  // Safe check for lastMonth data

  // const getCurrentAndPreviousMonth = () => {
  //   const now = new Date();

  //   const currentMonth = now.toISOString().slice(0, 7); // "YYYY-MM"

  //   // Subtract 1 month correctly
  //   const previous = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  //   const previousMonth = previous.toISOString().slice(0, 7);

  //   return { currentMonth, previousMonth };
  // };

  // const { currentMonth, previousMonth } = getCurrentAndPreviousMonth();

  // const monthToShow = data.budgetmonthfilter.length === 1;

  // // console.log("checking current month", currentMonth);

  // // Step 2: Get lastMonth (filtered by currentMonth)
  // const lastMonth =
  //   Array.isArray(data.budgetmonthfilter) && data.budgetmonthfilter.length > 0
  //     ? data.budgetmonthfilter.find((item) =>
  //         monthToShow
  //           ? item.year_month !== previousMonth
  //           : item.year_month === previousMonth
  //       ) || { Value: 0, year_month: "N/A" }
  //     : { Value: 0, year_month: "N/A" };

  // // console.log("checking last month", lastMonth);

  // // Step 3: Get previousMonth (filtered by previousMonth)
  // const previousMonthValues =
  //   Array.isArray(data.budgetpreviousmonth) &&
  //   data.budgetpreviousmonth.length > 0
  //     ? data.budgetpreviousmonth
  //         .filter((item) => item.year_month)
  //         .map((item) => item.Value)
  //     : [0];

  // // const lastMonth =
  // //   Array.isArray(data.budgetmonthfilter) && data.budgetmonthfilter.length > 0
  // //     ? data.budgetmonthfilter[data.budgetmonthfilter.length - 1]
  // //     : { Value: 0, year_month: "N/A" };

  // // // Safe check for previousMonth data
  // // const previousMonth =
  // //   Array.isArray(data.budgetpreviousmonth) &&
  // //   data.budgetpreviousmonth.length > 0
  // //     ? data.budgetpreviousmonth.map((item) => item.Value)
  // //     : [0];

  // const lastMonthValue = parseFloat(lastMonth.Value || 0);
  // const previousMonthValue = parseFloat(previousMonthValues[0] || 0);

  // // console.log(data.budgetmonthfilter);

  // Calculate percent change
  const percentChange =
    previousTotalBudget !== 0
      ? ((totalBudget - previousTotalBudget) / previousTotalBudget) * 100
      : 0;

  const isIncrease = percentChange >= 0;

  // const lastMonthCommission =
  //   Array.isArray(data.budgetcogsfilter) && data.budgetcogsfilter.length > 0
  //     ? data.budgetcogsfilter[data.budgetcogsfilter.length - 1]
  //     : { Value: 0, year_month: "N/A" };

  // // console.log(lastMonthCommission);
  // // console.log("checking previous month", previousMonthValue);

  // const lastMonthExpenses =
  //   Array.isArray(data.budgetexpensesfilter) &&
  //   data.budgetexpensesfilter.length > 0
  //     ? data.budgetexpensesfilter[data.budgetexpensesfilter.length - 1]
  //     : { Value: 0, year_month: "N/A" };

  // console.log(lastMonthCommission);

  return (
    <div className="dashboard-container">
      {/* Header with icon and title */}
      <div className="header-card">
        <div className="icon-container">
          <img src={iconBudgetCard} alt="icon-budget" />
        </div>
        <h1 className="title">
          {title}
        </h1>
      </div>

      {/* Main amount with trending indicator */}
      <div className="main-amount-container">
        <h2 className="main-amount">
          {totalBudget.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </h2>
        <div
          className={
            isIncrease ? "trend-indicator" : "trend-indicator-descrease"
          }
          style={{
            display: previousTotalBudget === 0 ? "none" : "block",
          }}
        >
          <span className="trend-icon">{isIncrease ? "↑" : "↓"}</span>
          <span>{Math.abs(percentChange).toFixed(2)}%</span>
        </div>
      </div>

      {/* Last month comparison */}
      <div className="comparison-container">
        <span className="comparison-label">Last month</span>
        <span className="comparison-value">
          {previousTotalBudget.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </span>
      </div>

      {/* Progress bar */}
      <div className="divider"></div>

      {/* Budget breakdown */}
      <div className="breakdown-container">
        <div className="breakdown-item">
          <h3 className="breakdown-label">AGENT'S COMMISSION BUDGET</h3>
          <p className="breakdown-value">
            {" "}
            {agentCommissionBudget.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </p>
        </div>
        <div className="breakdown-item">
          <h3 className="breakdown-label">EXPENSES BUDGET</h3>
          <p className="breakdown-value">
            {" "}
            {expensesBudget.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BudgetTotalMonthCard;
